import axios from "axios";
import { useState } from "react";
import Client from "shopify-buy";

const client = Client.buildClient({
  storefrontAccessToken: process.env.REACT_APP_ACCESS_TOKEN,
  domain: process.env.REACT_APP_STORE_DOMAIN,
});

export default function useShopify() {
  const [product, setProduct] = useState([]);
  const [products, setProducts] = useState([]);
  const [campaign, setCampaign] = useState({});
  const [note, setNote] = useState("");
  const [image, setImage] = useState();

  return {
    note,
    setNote,
    image,
    setImage,
    products,
    product,
    setProduct,
    campaign,
    fetchProducts(handles) {
      let productArr = [];
      // console.log('Fetching products with handles:', handles);
      
      const fetchProduct = (handle, index) => {
        // console.log(`Attempting to fetch product with handle: ${handle}`);
        new Promise((resolve, reject) => {
          client.product
            // Handles are typed into the admin by hand; a stray space makes Shopify return null.
            .fetchByHandle((handle || "").trim())
            .then((response) => {
              // console.log(`Successfully fetched product: ${handle}`, response);
              resolve(response);
              productArr[index] = response;
              if (response) {
                setProduct(response);
              }
            })
            .catch((error) => {
              console.error(`Error fetching product ${handle}:`, error);
              reject(error);
            });
        });
      };
      Promise.all([
        // eslint-disable-next-line array-callback-return
        handles.map((handle, index) => {
          fetchProduct(handle, index);
        }),
      ]).then(() => {
        // console.log('All products fetched:', productArr);
        setProducts(productArr);
      });
    },
    getCampaign(company, campaign) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.REACT_APP_API_URL}/gift/${company}/${campaign}`, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            resolve(response.data);
            setCampaign(response.data.campaign);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
    createOrder(data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env.REACT_APP_API_URL}/order`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
    getOrder(data) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/order/booking-number/${data}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error", error);
            resolve(false);
          });
      });
    },
    checkEmailOrdered(email, campaignId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/order/verified/${email}/${campaignId}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error", error);
            resolve(false);
          });
      });
    }
  };
}
